import LanguageProblems from '@/models/read/LanguageProblems';
import StructureProblems from '@/models/read/StructureProblems';
import Checklist from '@/models/read/Checklist';
import MathExtension from 'frontend-resources/js/MathExtension';

class Feedback {
    constructor({ letter, problems, checklists }) {
        this._letter = letter;
        this._languageProblems = this._determineLanguageProblems(problems);
        this._structureProblems = this._determineStructureProblems(problems);
        this._clarityCheck = this._formatChecklists(checklists.clarity);
        this._structureCheck = this._formatChecklists(checklists.standard || checklists.french);
    }

    get letter() {
        return this._letter;
    }

    get languageProblems() {
        return this._languageProblems;
    }

    get languageProblemsCount() {
        if (!this._languageProblems) {
            return 0;
        }
        return MathExtension.sum(this._languageProblems.categories.map(category => category.problems.length));
    }

    get structureProblems() {
        return this._structureProblems;
    }

    get clarityCheck() {
        return this._clarityCheck;
    }

    get structureCheck() {
        return this._structureCheck;
    }

    _determineLanguageProblems(problems) {
        if (problems === null || problems === undefined) {
            return null;
        }
        if (problems.language === undefined || problems.language === null) {
            return null;
        }

        return (new LanguageProblems({ sections: problems.language.sections }));
    }

    _determineStructureProblems(problems) {
        if (problems === null || problems === undefined) {
            return null;
        }
        if (problems.structure === undefined || problems.structure === null) {
            return null;
        }

        return (new StructureProblems({ sections: problems.structure.sections }));
    }

    _formatChecklists(checklists) {
        if (!checklists) {
            return null;
        }

        return Object.values(checklists)
            .filter(list => list.active)
            .map(list => new Checklist(list));
    }
}

export default Feedback;
